import React from "react";
import "./orders.css";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useUser } from "../../../context/UserContext";

const Orders = () => {
  const [purchase, setPurchase] = useState(null);
  const [loading, setLoading] = useState(true);
  const [packageDetails, setPackageDetails] = useState({});

  const { user } = useUser();

  useEffect(() => {
    if (!user || !user.user_id) return;

    axios
      .get("https://topfaculty.co.in/api/purchase_pay.php", {
        params: { StudentId: user.user_id },
      })
      .then(async (response) => {
        const purchases = response.data;

        console.log("Purchase Data:", purchases);
        setPurchase(purchases);
        setLoading(false);

        // Step 1: Collect all pkg ids from all purchases into a Set (to remove duplicates)
        const allPkgIds = new Set();

        purchases.forEach((item) => {
          // If package_ids is a JSON string like '["2","3"]'
          let ids = [];
          try {
            ids = JSON.parse(item.package_ids);
          } catch (e) {
            ids = Array.isArray(item.package_ids)
              ? item.package_ids
              : [item.package_ids];
          }
          ids.forEach((id) => allPkgIds.add(id));
        });
        console.log("Unique Package IDs:", Array.from(allPkgIds));
        // Step 2: Fetch details for each unique package ID
        const details = {};
        await Promise.all(
          Array.from(allPkgIds).map(async (pkgId) => {
            try {
              const res = await axios.get(
                "https://topfaculty.co.in/api/package_list.php",
                {
                  params: { PackageId: pkgId },
                }
              );
              const data = Array.isArray(res.data) ? res.data[0] : res.data;

              console.log("KUNDAN", pkgId, data);
              details[pkgId] = data;
            } catch (err) {
              console.error("Error fetching package detail for", pkgId, err);
            }
          })
        );

        setPackageDetails(details);
      })
      .catch((error) => {
        console.log("Error Fetching Batch Data", error);
        setLoading(false);
      });
  }, [user]);
  return (
    <>
      <div
        id="rs-latest-news"
         className="rs-courses-details "
        style={{ background: "#e5e5e5" }}
      >
          <img
          src="assetsfront/images/order.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />
        <div className="container">
          <div className="row rs-latest-list">
            <h1
              className="title text-center  mt-2 "
              style={{ fontWeight: "700" }}
            >
              My : <span class="info-color">Orders History</span>
            </h1>

            <div className="batch-table">
              {loading ? (
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#002347",
                    fontSize: "30px",
                  }}
                >
                  Please Wait
                  <span className="dot-loader">
                    {[...Array(9)].map((_, i) => (
                      <span className="dot" key={i}></span>
                    ))}
                  </span>
                </span>
              ) : purchase && purchase.length > 0 ? (
                purchase.map((item, index) => {
                  // Parse package_ids safely
                  let package_ids = [];
                  try {
                    package_ids = JSON.parse(item.package_ids);
                  } catch {
                    package_ids = Array.isArray(item.package_ids)
                      ? item.package_ids
                      : [item.package_ids];
                  }

                  return (
                    <div className="batch-card-row" key={index}>
                     
                      <img
                        src={
                          item.status === "paid"
                            ? "assetsfront/images/paid.avif"
                            : "assetsfront/images/fail.avif"
                        }
                        alt="Payment Status"
                      />

                      <div className="batch-info">
                        <h5>{index + 1}. Purchased Packages:</h5>
                        {package_ids.map((pkgId, i) => (
                          <div
                            className="m-1"
                            key={i}
                            style={{
                              padding: " 13px 8px",
                              background: "aliceblue",
                              border: "1px solid #eaeaea",
                              borderRadius: "3px",
                              width: "90%",
                            }}
                          >
                            ({index + 1}.{i + 1}){" "}
                            <strong style={{ color: "#0d6efd" }}>
                              {packageDetails[pkgId]?.pack_name || "Loading..."}
                            </strong>
                            <div style={{ color: "gray" }}>
                              Subjects:{" "}
                              {packageDetails[pkgId]?.sub_subjects || "-"}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="batch-date">
                        Txn-Id:{" "}
                        <small style={{ color: "gray" }}>{item.txn_id}</small>
                        <br />
                        Order-Id:{" "}
                        <small style={{ color: "gray" }}>{item.order_no}</small>
                        <br />
                        <small style={{ color: "gray" }}>
                          {item.date} | {item.time}
                        </small>
                      </div>

                      <div className="batch-price">₹ {item.amount}</div>
                      <div className="batch-status">Purchased</div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    boxShadow:
                      "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
                  }}
                >
                  <p
                    className="mt-2"
                    style={{ textAlign: "center", fontWeight: "800" }}
                  >
                    No Batches Purchased
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
